<template>
  <div class="data-card">
    <div class="data-card__header">
      <h3 class="my-0">Задачи</h3>
      <div v-if="showSaveAllFiles" class="d-flex flex-wrap justify-content-end flex-gap-10">
        <el-button size="medium" @click="onSaveAllFiles">Скачать все файлы</el-button>
      </div>
    </div>

    <div v-for="step in steps" class="mt-3" :key="step.ordinalNumber">
      <FilesStep v-if="step.completionMethod === '0'" :step="step" :key="`${item.visitOrderId}_${step.ordinalNumber}`" />
      <CommentStep v-else :step="step" :key="`${item.visitOrderId}_${step.ordinalNumber}`" />
    </div>

    <el-alert v-if="!steps.length" class="mt-3" title="Задачи по услуге отсутствуют" type="warning" :closable="false" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FilesStep from '@/components/orders/steps/FilesStep';
import CommentStep from '@/components/orders/steps/CommentStep';
import apiClient from '@/services/api/apiClient';

export default {
  components: {
    FilesStep,
    CommentStep,
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
      updateProgress: 'orders/updateProgress',
    }),
    steps() {
      return this.item.service?.serviceSteps || [];
    },
    showSaveAllFiles() {
      return this.steps.some((step) => step.files && step.files.length);
    },
  },
  methods: {
    ...mapActions({
      getZipKey: 'files/getZipKey',
    }),
    onSaveAllFiles() {
      const files = this.steps.reduce((acc, step) => {
        acc = [...acc, ...step.files];
        return acc;
      }, []);

      const filesOldStructure = files.map((file) => ({
        fileName: file.fileName,
        id: file.fileId,
        url: file.fileUrl,
        contentType: file.fileContentType,
      }));
      this.getZipKey({ files: filesOldStructure })
        .then((data) => {
          const link = document.createElement('a');
          link.href = `${apiClient.defaults.baseURL}/files/zip/${data.downloadKey}`;
          link.click();
        });
    },
  },
};
</script>
